export default __webpack_public_path__ + "static/media/mayfull.822cda6e.png";